import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Globals } from '../models/globals.model';

@Injectable({
  providedIn: 'root'
})
export class KPIFormulaBuilderService {

  apiUri: string;
  graphUri: string;

  getConstantsApi = "api/Constants";
  getProcessNamesApi = "KPIFormulaBuilder/GetProcessNames";
  getMathFunctionsApi = "KPIFormulaBuilder/GetMathFunctions";
  getFormulaNamesApi = 'KPIFormulaBuilder/GetFormulas';
  saveFinalFormulaApi = 'KPIFormulaBuilder/saveFormula';
  getEvaluateFormulaApi = 'KPIFormulaBuilder/EvaluateFormula';
  getTestFormulaResultApi = 'KPIFormulaBuilder/GetTestFormulaResult';
  getFormulaDetailsOnKpiIdApi = 'KPIFormulaBuilder/GetFormulaDetailsOnKpiId';
  getTokenApi = 'KPIFormulaBuilder/getToken';
  getFormulaOnKpiIdApi = 'KPIFormulaBuilder/GetFormulaOnKpiId';
  getDeleteFormulaApi = 'KPIFormulaBuilder/deleteFormula';
  getEditFormulaApi = 'KPIFormulaBuilder/editFormula';

  constructor(private readonly globals: Globals, private readonly http: HttpClient) {
    this.apiUri = this.globals.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  saveConstantFormula(constants) {
    return this.http.post<any>(this.apiUri + this.getConstantsApi, constants);
  }

  updateConstantFormula(constants) {
    return this.http.put<any>(this.apiUri + this.getConstantsApi, constants);
  }

  getConstantsFormula() {
    return this.http.get(this.apiUri + this.getConstantsApi);
  }

  deleteConstantModel(selectedConstantId) {
    let params = { constantId: selectedConstantId };
    return this.http.delete(this.apiUri + this.getConstantsApi, {
      params: params
    });
  }

  getProcessNames() {
    return this.http.get(this.apiUri + this.getProcessNamesApi);
  }

  getMathFunctions() {
    return this.http.get(this.apiUri + this.getMathFunctionsApi);
  }

  getFormulaNames() {
    return this.http.get(this.apiUri + this.getFormulaNamesApi);
  }

  saveFinalFormula(deletedKpiIds, formulaList) {
    return this.http.post<any>(this.apiUri + this.saveFinalFormulaApi + '?deletedKpiIds=' + deletedKpiIds, formulaList);
  }

  getEvaluateFormula(stTime, edTime, formulaDetails) {
    return this.http.post<any>(this.apiUri + this.getEvaluateFormulaApi + '?startdate='+ stTime + '&enddate=' + edTime, formulaDetails);
  }

  getTestFormulaResult(mainFormulaId) {
    return this.http.get(this.apiUri + this.getTestFormulaResultApi + '?formulaId=' + mainFormulaId);
  }

  getFormulaDetailsOnKpiId(formulaId) {
    return this.http.get(this.apiUri + this.getFormulaDetailsOnKpiIdApi + '?formulaId=' + formulaId);
  }

  getTokendata() {
    return this.http.get(this.apiUri + this.getTokenApi);
  }

  getFormulaOnKpiId(formulaId) {
    return this.http.get(this.apiUri + this.getFormulaOnKpiIdApi + '?formulaId=' + formulaId);
  }

  getDeleteFormula(kpiDetails) {
    return this.http.post<any>(this.apiUri + this.getDeleteFormulaApi, kpiDetails);
  }

  getEditFormula(data) {
    return this.http.post<any>(this.apiUri + this.getEditFormulaApi, data);
  }
  
}
